import * as GBConst from "./GBConst";
import { cloneObj } from "./GBUtil";

export const getNewPackTable = () => {
    return cloneObj(GBConst.packTableDefaults);
};

export const resizePackTable = (pt, numRows, numCols) => {
    let table = JSON.parse(JSON.stringify(pt));
    table.GBRowCount = numRows;
    table.GBColCount = numCols;
    table.RDec = size2dArray(table.RDec, numRows, numCols, 0);
    table.tableData.value = size2dArray(table.tableData.value, numRows, numCols, "");
    table.RowIds = size1dArray(table.RowIds, numRows, 0);
    table.LockedCells = size2dArray(table.LockedCells, numRows, numCols, false);
    table.MinAllowedVal = size2dArray(table.MinAllowedVal, numRows, numCols, 0);
    table.MaxAllowedVal = size2dArray(table.MaxAllowedVal, numRows, numCols, 100);
    table.FontStyles = size2dArray(table.FontStyles, numRows, numCols, { intArray: [] });
    table.FontColors = size2dArray(table.FontColors, numRows, numCols, 0);
    table.FontSizes = size2dArray(table.FontSizes, numRows, numCols, 10);
    table.GBCellComment = size2dArray(table.GBCellComment, numRows, numCols, "");
    table.IndentRowText = size1dArray(table.IndentRowText, numRows, { xoffset: 0, Value: false });
    table.Alignments = size2dArray(table.Alignments, numRows, numCols, GBConst.hAlign.left);
    table.GBColWidths.push(300);
    for (let i = 1; i < numCols; i++) {
        table.GBColWidths.push(90);
    }
    return table;
};

const size1dArray = (array, row, defaultVal = 0) => {
    let array2 = [];
    for (let x = 0; x < row; x++) {
        array2[x] = defaultVal;
    }

    if (Math.min(row - 1, array.length - 1) > 0) {
        for (let x = 0; x <= Math.min(row - 1, array.length - 1); x++) {
            array2[x] = array[x];
        }
    }

    return array2;

    // for (var x = 0; x < row; x++) {
    //     array[x] = [];
    //     for (var y = 0; y < col; y++) {
    //         array[x][y] = defaultVal;
    //     }
    // }
};

const size2dArray = (array, row, col, defaultVal = 0) => {
    let array2 = [];
    for (let x = 0; x < row; x++) {
        array2[x] = [];
        for (let y = 0; y < col; y++) {
            array2[x][y] = cloneObj(defaultVal);
        }
    }

    if (Math.min(row - 1, array.length - 1) > 0) {
        for (let x = 0; x <= Math.min(row - 1, array.length - 1); x++) {
            if (Math.min(col - 1, array[x].length - 1) > 0) {
                for (let y = 0; y <= Math.min(col - 1, array[x].length - 1); y++) {
                    array2[x][y] = array[x][y];
                }
            }
        }
    }

    return array2;

    // for (var x = 0; x < row; x++) {
    //     array[x] = [];
    //     for (var y = 0; y < col; y++) {
    //         array[x][y] = defaultVal;
    //     }
    // }
};

export const addRowToPackTable = (pt, defaultVal = 0, rDec = 0) => {
    // if (!defaultVal) defaultVal = 0;
    // if (!rDec) rDec = 0;
    let table = cloneObj(pt);
    let tableData = table.tableData.value;

    tableData[tableData.length] = []; //add a row
    for (let y = 0; y <= tableData[tableData.length - 2].length - 1; y++) {
        //duplicate column length of previous last row for new last row
        tableData[tableData.length - 1][y] = defaultVal;
    }
    table.GBRowCount = tableData.length;

    let RDec = table.RDec;
    RDec[RDec.length] = []; //add a row
    for (let y = 0; y <= RDec[RDec.length - 2].length - 1; y++) {
        //duplicate column length of previous last row for new last row
        RDec[RDec.length - 1][y] = rDec;
    }

    table.RowIds[table.RowIds.length] = 0;

    let LockedCells = table.LockedCells;
    LockedCells[LockedCells.length] = [];
    for (let y = 0; y <= LockedCells[LockedCells.length - 2].length - 1; y++) {
        LockedCells[LockedCells.length - 1][y] = false;
    }

    let MinAllowedVal = table.MinAllowedVal;
    MinAllowedVal[MinAllowedVal.length] = [];
    for (let y = 0; y <= MinAllowedVal[MinAllowedVal.length - 2].length - 1; y++) {
        MinAllowedVal[MinAllowedVal.length - 1][y] = 0;
    }

    let MaxAllowedVal = table.MaxAllowedVal;
    MaxAllowedVal[MaxAllowedVal.length] = [];
    for (let y = 0; y <= MaxAllowedVal[MaxAllowedVal.length - 2].length - 1; y++) {
        MaxAllowedVal[MaxAllowedVal.length - 1][y] = 100;
    }

    let FontStyles = table.FontStyles;
    FontStyles[FontStyles.length] = [];
    for (let y = 0; y <= FontStyles[FontStyles.length - 2].length - 1; y++) {
        FontStyles[FontStyles.length - 1][y] = { intArray: [] };
    }

    let FontColors = table.FontColors;
    FontColors[FontColors.length] = [];
    for (let y = 0; y <= FontColors[FontColors.length - 2].length - 1; y++) {
        FontColors[FontColors.length - 1][y] = 0;
    }

    let FontSizes = table.FontSizes;
    FontSizes[FontSizes.length] = [];
    for (let y = 0; y <= FontSizes[FontSizes.length - 2].length - 1; y++) {
        FontSizes[FontSizes.length - 1][y] = 17;
    }

    let GBCellComment = table.GBCellComment;
    GBCellComment[GBCellComment.length] = [];
    for (let y = 0; y <= GBCellComment[GBCellComment.length - 2].length - 1; y++) {
        GBCellComment[GBCellComment.length - 1][y] = "";
    }

    let Alignments = table.Alignments;
    Alignments[Alignments.length] = [];
    for (let y = 0; y <= Alignments[Alignments.length - 2].length - 1; y++) {
        Alignments[Alignments.length - 1][y] = GBConst.hAlign.left;
    }

    let IndentRowText = table.IndentRowText;
    IndentRowText[IndentRowText.length] = { xoffset: 0, Value: false };

    return table;
};

export const addMergedCellsToArray = (array, startRow, startCol, numRows, numCols) => {
    let array1 = JSON.parse(JSON.stringify(array));

    array1[array1.length] = {
        startCol: startCol,
        startRow: startRow,
        numCols: numCols,
        numRows: numRows,
    };

    return array1;
};

export const lockPackRowCol = (pt, row, col, lock, gray = true) => {
    if (lock) {
        pt["LockedCells"][row][col] = true;
        if (gray) {
            pt["FontColors"][row][col] = 8421504;
        }
    } else {
        pt["LockedCells"][row][col] = false;
        pt["FontColors"][row][col] = 0;
    }
    return pt;
};

export const lockPackTable = (pt, row, lock, gray = true) => {
    for (let col = 1; col <= pt["GBColCount"]; col++) {
        pt = lockPackRowCol(pt, row, col, lock, gray);
    }
    return pt;
};

export const indentPackTable = (pt, row, indent, offset) => {
    if (indent) {
        pt.IndentRowText[row] = { xoffset: offset, Value: true };
    } else {
        pt.IndentRowText[row] = { xoffset: 0, Value: false };
    }
    return pt;
};

export const alignNumericCellsRight = (pt) => {
    for (let row = 0; row < pt.GBRowCount; row++) {
        for (let col = 0; col < pt.GBColCount; col++) {
            if (typeof pt.tableData.value[row][col] === "number") {
                pt.Alignments[row][col] = GBConst.hAlign.right;
            }
        }
    }
    return pt;
};
